import { request } from "../";
import config from "../../../config/common";
import { VISUAL_REFINEMENTS_REQUEST } from "../constants";
import getSearchBaseUrl from "./getSearchBaseUrl";
import stringifyParams from "./stringifyParams";

const {
  api: {
    product: {
      search: { timeout, visualRefinements: visualRefinementsUrl },
    },
  },
} = config;

export const MAX_VISUAL_REFINEMENTS_LIMIT = 30;
export const DEFAULT_VISUAL_REFINEMENTS_LIMIT = 30;

const getRefinementKey = (refinement) =>
  refinement.split(/[:=]/)[0]?.trim().toLowerCase();

const getRefinementValue = (refinement) => {
  const [, value = ""] = refinement.split(/[:=]/);

  return value.trim();
};

const getRefinementEntries = (refine) =>
  typeof refine === "string" ? refine.split("|").filter(Boolean) : [];

export const hasUnsupportedVisualRefinementFilters = (refine) =>
  getRefinementEntries(refine).some(
    (refinement) => getRefinementKey(refinement) !== "floor",
  );

export const getFloorParamFromRefine = (refine) => {
  const floorRefinement = getRefinementEntries(refine).find(
    (refinement) => getRefinementKey(refinement) === "floor",
  );

  if (!floorRefinement) {
    return undefined;
  }

  const floorValues = getRefinementValue(floorRefinement)
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean);

  return floorValues.length > 0 ? floorValues.join(",") : undefined;
};

const getLimitParam = (limit) => {
  const parsedLimit = parseInt(limit);

  if (!parsedLimit) {
    return DEFAULT_VISUAL_REFINEMENTS_LIMIT;
  }

  return Math.min(parsedLimit, MAX_VISUAL_REFINEMENTS_LIMIT);
};

export const buildVisualRefinementsParams = ({
  q,
  cid,
  store,
  lang,
  refine,
  floor,
  limit,
} = {}) => {
  const params = {
    ...(cid ? { cid } : { q }),
    store,
    lang,
    limit: getLimitParam(limit),
  };
  const floorParam = floor || getFloorParamFromRefine(refine);

  if (floorParam) {
    params.floor = floorParam;
  }

  return params;
};

export const shouldFetchVisualRefinements = ({ query = {}, pageNumber = 1 }) =>
  pageNumber === 1 &&
  Boolean(query.q || query.cid) &&
  Boolean(query.store) &&
  Boolean(query.lang) &&
  !hasUnsupportedVisualRefinementFilters(query.refine);

const validateVisualRefinementsParams = (params) => {
  if (!params.q && !params.cid) {
    return Promise.reject(
      new Error(
        "The visual refinements query string must contain a q or cid parameter",
      ),
    );
  }

  if (!params.store) {
    return Promise.reject(
      new Error(
        "The visual refinements query string must contain a store parameter",
      ),
    );
  }

  if (!params.lang) {
    return Promise.reject(
      new Error(
        "The visual refinements query string must contain a lang parameter",
      ),
    );
  }

  return null;
};

export const visualRefinements = (
  params = {},
  uuid,
  xSiteOriginFromServerRequest,
) => {
  const requestParams = buildVisualRefinementsParams(params);
  const validationError = validateVisualRefinementsParams(requestParams);

  if (validationError) {
    return validationError;
  }

  const qs = stringifyParams(requestParams);
  const url = `${getSearchBaseUrl(
    xSiteOriginFromServerRequest,
  )}${visualRefinementsUrl}?${qs}`;

  return request(url, { timeout }, VISUAL_REFINEMENTS_REQUEST, uuid);
};
